import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    fetchMenuItems();
  }, []);

  const fetchMenuItems = async () => {
    try {
      const response = await fetch('/api/menu');
      const data = await response.json();
      setMenuItems(data);
    } catch (error) {
      console.error('Error fetching menu items:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-logo">
            <img src="/staticimages/be50grlogo.png" alt="be50.gr" className="logo-image" />
            <span className="logo-text">be50.gr</span>
          </Link>

          <button 
            className="navbar-toggle"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
            {menuItems.map((item) => (
              <Link 
                key={item.id} 
                to={item.path} 
                className="navbar-link"
                onClick={() => setIsOpen(false)}
              >
                {item.title}
              </Link>
            ))}
            
            {token ? (
              <>
                {user.role === 'admin' && (
                  <Link to="/admin" className="navbar-link">Admin</Link>
                )}
                {user.role === 'freelancer' && (
                  <Link to="/freelancer" className="navbar-link">Το Dashboard μου</Link>
                )}
                <button onClick={handleLogout} className="btn btn-outline btn-sm">
                  Αποσύνδεση
                </button>
              </>
            ) : (
              <Link to="/login" className="btn btn-primary btn-sm">
                Σύνδεση
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
